import { Link } from "react-router-dom";
import { useLang } from "@/i18n";
import { Brand } from "@/components/Logo";

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="section-wrap footer-inner">
        <Link to="/" className="brand-link" data-testid="footer-brand-link" aria-label="RKJ GST Consultancy home">
          <Brand light />
        </Link>
        <p className="footer-tagline">{t("footer.tagline")}</p>
        <div className="footer-links">
          <Link to="/blog" data-testid="footer-journal-link">{t("nav.journal")}</Link>
          <span>{t("footer.rights")}</span>
        </div>
      </div>
    </footer>
  );
}
